import { render, staticRenderFns } from "./DataOperation.vue?vue&type=template&id=ebb2cf10&scoped=true&"
import script from "./DataOperation.vue?vue&type=script&lang=js&"
export * from "./DataOperation.vue?vue&type=script&lang=js&"
import style0 from "./DataOperation.vue?vue&type=style&index=0&id=ebb2cf10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb2cf10",
  null
  
)

export default component.exports